import { render, staticRenderFns } from "./MoreMenuMoney.vue?vue&type=template&id=436b92af&scoped=true&"
import script from "./MoreMenuMoney.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuMoney.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuMoney.vue?vue&type=style&index=0&id=436b92af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b92af",
  null
  
)

export default component.exports